module.exports = __webpack_public_path__ + "img/icons8-google.648fa9fa.svg";